<div class="wrapper">
  <button
    type="button"
    class="responsive-sidebar-toggle"
    (click)="toggleResponsiveSidebar()"
    [attr.aria-expanded]="isResponsiveSidebarOpen()"
    aria-controls="main-sidebar"
    aria-label="Open navigation menu">
    <i class="material-icons" aria-hidden="true">menu</i>
  </button>

  <div
    class="sidebar-backdrop"
    [class.is-visible]="isResponsiveSidebarOpen()"
    (click)="closeResponsiveSidebar()"
    aria-hidden="true">
  </div>

  <div id="main-sidebar" class="sidebar" data-color="danger" data-background-color="black">
    <app-sidebar></app-sidebar>
  </div>
  <div class="main-panel">
    <router-outlet></router-outlet>
    <div *ngIf="isMaps('maps')">
      <app-footer></app-footer>
    </div>
  </div>
</div>
